import React, { Component } from 'react';
import PropTypes from 'prop-types';

import SessionStore from '../../stores/SessionStore';
import SessionActionCreator from '../../actions/SessionActionCreator';

import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import {
  NavigationButtonGroup,
  NavigationButton,
} from 'web-ui-components/lib/navigation/buttons';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { GenericIntegerInput } from 'web-ui-components/lib/data/capture';
import { MultiButtonModal } from 'web-ui-components/lib/layout/content';

export class OTPChallenge extends Component {
  constructor(props) {
    super(props);

    this.state = {
      OTPValue: null,
      isTokenLoading: false,
      showResendPasscodeModal: false,
    };
  }

  componentDidMount() {
    SessionStore.addChangeListener(this.onSessionStoreChange);
  }

  componentWillUnmount() {
    SessionStore.removeChangeListener(this.onSessionStoreChange);
  }

  onSessionStoreChange = () => {
    if (!SessionStore.isStepUpMode()) {
      return;
    }

    this.setState({
      isTokenLoading: SessionStore.isTokenLoading(),
      ...(SessionStore.isTokenError() && { isValidationError: true }),
    });
  };

  handleResendPasscode = () => {
    SessionActionCreator.requestOTPAuthentication();
    this.toggleResendPasscodeModal();
  };

  toggleResendPasscodeModal = () => {
    this.setState((prevState) => ({
      showResendPasscodeModal: !prevState.showResendPasscodeModal,
    }));
  };

  render() {
    const { content, handleCancel } = this.props;
    const {
      OTPValue,
      isTokenLoading,
      isValidationError,
      showResendPasscodeModal,
    } = this.state;

    return (
      <div className="web-ui-components">
        <PageHeading>{content.OTP.pageHeading}</PageHeading>
        <StandardBody>
          <p>
            {`${content.OTP.body.replace(
              '{number}',
              SessionStore.getPreferredOTPNumber()
            )}`}
          </p>
        </StandardBody>
        <GenericFieldWrapper
          inputId="passcode-wrapper"
          titleText="Passcode"
          validationMessage={
            isValidationError ? content.OTP.validationError : null
          }
        >
          <GenericIntegerInput
            id="passcode-input"
            onChange={(value) =>
              this.setState({ OTPValue: value, isValidationError: false })
            }
            value={OTPValue}
          />
        </GenericFieldWrapper>
        <NavigationButtonGroup
          primaryButton={
            <NavigationButton.Primary
              labelText={content.continueButtonText}
              onClick={() => SessionActionCreator.submitOTP(OTPValue)}
              isLoading={isTokenLoading}
            />
          }
          secondaryButtons={
            <NavigationButton.Secondary
              labelText={content.cancelButtonText}
              onClick={handleCancel}
            />
          }
          tertiaryButtons={
            <NavigationButton.Tertiary
              labelText={content.OTP.resendPasscode}
              onClick={this.handleResendPasscode}
            />
          }
        />
        <MultiButtonModal
          isOpen={showResendPasscodeModal}
          onClose={this.toggleResendPasscodeModal}
          titleText={content.OTP.passcodeOnWay}
          buttons={[
            <NavigationButton.Primary
              labelText={content.OTP.gotIt}
              onClick={this.toggleResendPasscodeModal}
            />,
          ]}
        >
          <StandardBody>{content.OTP.resendDetails}</StandardBody>
        </MultiButtonModal>
      </div>
    );
  }
}

OTPChallenge.propTypes = {
  handleCancel: PropTypes.func.isRequired,
  content: PropTypes.object.isRequired,
};
